import util from 'zmfront-framework/src/utils/util'
import httpservice from 'zmfront-framework/src/utils/httpservice'



const zmGlobal = {};


zmGlobal.excelJobList = [];

zmGlobal.timer = null;


/**
 * 刷新选项表
 */
zmGlobal.refreshTableSimple = function () {
    return new Promise((resolve,reject) =>{
        httpservice.get('bas/option/utable/list', {}).then(res => {
            // console.log('选项表明细刷新成功');
            util.set("tableSimpleDetail", res)
            resolve()
        }).catch(res => {
            // console.log('选项表明细刷新失败');
            reject()
        });
    })

}



/**
 * 异步导出后调用此方法向导出列表插入一条数据
 * @param option
 */
zmGlobal.addExcelJob = function (option){
    if(!option.excelName){
        util.show('Excel名称不能为空！');
        return;
    }
    if(!option.id){
        util.show('Excel任务id不能为空');
        return;
    }
    zmGlobal.excelJobList.unshift({
        excelName: option.excelName,
        id : option.id,
        status : 0,
        failReason: '',
        fileUrl : ''
    });
    if(!zmGlobal.timer){
        startExcelJobTimer();
    }

    /*var ifa = true;
    var count = 0;
    var interval = setInterval(function() {
        if(ifa){
            if(count >= 180) {
                window.clearInterval(interval);
            }
            count ++;
            var _params = {
                id : option.id
            };
            var token = util.get("token");
            if(token){
                httpservice.get('cmn/excel/find', _params).then(res => {
                    if(res.status == 1 || res.status == 2){
                        for(var i = 0;i<zmGlobal.excelJobList.length;i++){
                            if(zmGlobal.excelJobList[i].id == option.id){
                                zmGlobal.excelJobList[i].status = res.status;
                                zmGlobal.excelJobList[i].createDatetime = res.createDatetime;
                                zmGlobal.excelJobList[i].fileId = res.fileId;
                                zmGlobal.excelJobList[i].fileUrl = res.fileUrl;
                                zmGlobal.excelJobList[i].failReason = res.failReason;
                                break;
                            }
                        }
                        ifa = false;
                    }
                });
            }else{
                window.clearInterval(interval);
            }
        }else{
            window.clearInterval(interval);
        }
    }, 10000);*/
};

const clearExcelJobTimer = function () {
    let clearFlag = true;
    for (let i = 0; i < zmGlobal.excelJobList.length; i++) {
        if (zmGlobal.excelJobList[i].status === 0) {
            clearFlag = false;
            break;
        }
    }
    if(zmGlobal.timer && clearFlag){
        window.clearInterval(zmGlobal.timer);
        zmGlobal.timer = null;
    }
};

const startExcelJobTimer = function () {
    console.log('开启excel定时器');
    // let undone = true;
    zmGlobal.timer = setInterval(function () {
        // if (undone) {
            //如果用户信息不存在后 清除定时器
            var token = util.get("token");
            if(token){
                httpservice.get('cmn/excel/list', {}).then(res => {
                    if (res && res.length > 0) {
                        let jobIds = [];
                        let downCount = 0;
                        res.forEach((item,index) => {
                            if(item.status == 1 || item.status == 2){
                                console.log(item);
                                for (let i = 0; i < zmGlobal.excelJobList.length; i++) {
                                    if (zmGlobal.excelJobList[i].id == item.id) {
                                        zmGlobal.excelJobList[i].createDatetime = item.createDatetime;
                                        zmGlobal.excelJobList[i].status = item.status;
                                        zmGlobal.excelJobList[i].fileId = item.fileId;
                                        zmGlobal.excelJobList[i].fileUrl = item.fileUrl;
                                        zmGlobal.excelJobList[i].failReason = item.failReason;
                                        if(item.status == 1 && item.fileUrl){
                                            let is_type = JSON.parse(sessionStorage.getItem('sysType'));
                                            if(downCount < 1){
                                                let name = zmGlobal.excelJobList[i].excelName;
                                                name = name.replace("&","%26");
                                                if(!(item.approvalUserName && item.approvalUserName != '')){
                                                    if(is_type == "tms"){
                                                        zmGlobal.openDownloadDialog(zmGlobal.excelJobList[i].fileUrl,name)
                                                    }
                                                }
                                            }else{
                                                let url = zmGlobal.excelJobList[i].fileUrl;
                                                let name = zmGlobal.excelJobList[i].excelName;
                                                name = name.replace("&","%26");
                                                setTimeout(() => {
                                                    if(!(item.approvalUserName && item.approvalUserName != '')){
                                                        if(is_type == "tms"){
                                                            zmGlobal.openDownloadDialog(url,name)
                                                        }
                                                    }
                                                }, (1000*downCount))
                                            }
                                            downCount ++;
                                            if(!(item.approvalUserName && item.approvalUserName != '')){
                                                if(is_type == "tms"){
                                                    jobIds.push(zmGlobal.excelJobList[i].id)
                                                } 
                                            }
                                        }
                                        break;
                                    }
                                }
                            }
                        });
                        updateExcelStatusByIds(jobIds);
                        clearExcelJobTimer();
                       /* undone = false;
                        for (let i = 0; i < zmGlobal.excelJobList.length; i++) {
                            if (zmGlobal.excelJobList[i].status === 0) {
                                undone = true;
                                break;
                            }
                        }*/
                    }
                });
            }else{
                window.clearInterval(zmGlobal.timer);
                zmGlobal.timer = null;
            }
        /*} else {
            window.clearInterval(zmGlobal.timer);
        }*/
    }, 10000);
}

// 初始化导出列表
zmGlobal.initExcelJobByUser = function() {
    httpservice.get('cmn/excel/list', {}).then(res => {
        if (res && res.length > 0) {

            zmGlobal.excelJobList = res;

            let queryFlag = false;
            res.forEach((item,index) => {
                if(item.status === 0){
                    queryFlag = true;
                }
            });

            if(queryFlag){
                if(!zmGlobal.timer){
                    startExcelJobTimer();
                }
            }
        }
    });
};

//global.initExcelJobByUser();

//excelJob下载触发
zmGlobal.updateExcelStatus = function (excelJobId) {
    var _params = {id: excelJobId};
    httpservice.post('cmn/excel/update', _params).then(res => {
        if(res) {
            if (zmGlobal.excelJobList && zmGlobal.excelJobList.length > 0) {
                for (var i = 0; i < zmGlobal.excelJobList.length; i++) {
                    if (zmGlobal.excelJobList[i].id == excelJobId) {
                        zmGlobal.excelJobList.splice(i, 1);
                        clearExcelJobTimer();
                        break;
                    }
                }
            }
        }
    })
};
const updateExcelStatusByIds = function (jobIds) {
    if(jobIds && jobIds.length > 0){
        for( let i = 0;i < jobIds.length; i++){
            if(zmGlobal.excelJobList && zmGlobal.excelJobList.length > 0){
                for (var j = 0; j < zmGlobal.excelJobList.length; j++) {
                    if (zmGlobal.excelJobList[j].id == jobIds[i]) {
                        zmGlobal.excelJobList.splice(j, 1);
                        break;
                    }
                }
            }
        }
        for( let i = 0;i < jobIds.length; i++){
            var _params = {id: jobIds[i]};
            httpservice.post('cmn/excel/update', _params)
        }
    }
};

//excelJob清除触发
zmGlobal.clearExcelJob = function (jobId) {
    if(!jobId){
        util.show("请选择要清除的Excel任务！");
        return;
    }
    //清除数据库数据
    httpservice.post('cmn/excel/delete', {id: jobId}).then(res => {
        if(res){
            util.show("清除成功");
            if(zmGlobal.excelJobList && zmGlobal.excelJobList.length > 0){
                for(var i=0;i<zmGlobal.excelJobList.length;i++){
                    if(zmGlobal.excelJobList[i].id == jobId){
                        zmGlobal.excelJobList.splice(i,1);
                        clearExcelJobTimer();
                        break;
                    }
                }
            }
        }
    });

};

zmGlobal.downloadImportExcel = function(batchNo, type) {
    if(!batchNo){
        util.show('批次号不能为空',1);
        return;
    }
    var downloadUrl = type == 2 ? 'cmn/excelimport/errorfile/download' : 'cmn/excelimport/importfile/download'
    httpservice.get(downloadUrl, {str: batchNo}).then(res => {
        if(res && res.str){
            var elemIF = document.createElement("iframe");
            elemIF.src = res.str;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        }else {
            util.show('无对应文件',1);
        }
    });
};

zmGlobal.downloadByFileId = function (fileId,fileName) {
    httpservice.post('cmn/file/list', {idStr: fileId}).then(res => {
        if(res && res.length > 0){
            if(res[0].imgUrl){
                zmGlobal.openDownloadDialog(res[0].imgUrl,fileName)
            }else{
                util.show('未获取到对应文件', 1);
            }
        }else{
            util.show('未获取到对应文件！', 1);
        }
    }).catch(res => {
        util.show('获取文件路径异常', 1);
    });
};


zmGlobal.openDownloadDialog = function(url, saveName) {
    //没有文件名 默认temp
    saveName = saveName ? saveName : 'temp';
    //获取文件路径中的文件后缀名
    var i1 = url.lastIndexOf(".");
    var i2 = url.length;
    var itype = url.substring(i1,i2);
    // console.log(itype)
    //获取文件命中的文件后缀名, 和文件路径中的比较， 如果相同文件名直接使用saveName,否则文件名为saveName+后缀名
    let fileName = '';
    var n1 = saveName.lastIndexOf(".");
    if(n1 > -1){
        var n2 = saveName.length;
        var ntype = saveName.substring(n1,n2);
        if( itype == ntype){
            fileName = saveName;
        }else{
            fileName= saveName+'.'+itype;
        }
    }else{
        fileName= saveName+itype;
    }

    // console.log(fileName)

    //下载，如果为txt文本 不加filename参数
    const a = document.getElementById('zmdownloadA')
    if('.txt' == itype){
        a.href = url;
    }else{
        a.href = url+"?filename="+fileName;
    }

    a.click()
    window.URL.revokeObjectURL(a.href);



};

zmGlobal.removeDataTableCache = function(tableName) {
    if(!tableName){
        return;
    }
    if(sessionStorage.length > 0){
        let dataCallTableInfo = util.get('dataCallTableInfo');
        if(dataCallTableInfo && dataCallTableInfo[tableName] && dataCallTableInfo[tableName].length > 0){
            for(let i = 0; i < dataCallTableInfo[tableName].length; i++){
                for (let j = 0; j < sessionStorage.length; j++) {
                    if(sessionStorage.key(j) === 'tf:'+dataCallTableInfo[tableName][i] ||
                        sessionStorage.key(j).startsWith('tf:'+dataCallTableInfo[tableName][i]+':') ){
                        sessionStorage.removeItem(sessionStorage.key(j));
                    }
                }
            }
        }
    }
};
/*removeOther: function(keys){
    if(sessionStorage.length > 0){
        let removeKes = [];
        for (let i = 0;i<sessionStorage.length;i++) {
            if(!sessionStorage.key(i).startsWith('configTableNo:') && !sessionStorage.key(i).startsWith('routeparam:')
                &&  keys.indexOf(sessionStorage.key(i)) < 0){
                removeKes.push(sessionStorage.key(i));
            }
        }
        if(removeKes.length > 0){
            removeKes.forEach((item,index) => {
                sessionStorage.removeItem(item);
            });
        }
    }

},*/

zmGlobal.getMenuIcons = function () {
    return [
        {value:'icon_pingtai', label:'平台'},
        {value:'icon_pingtaishezhi', label:' 平台设置'},
        {value:'icon_zuzhi2', label:' 组织'},
        {value:'icon_jichu', label:' 基础'},
        {value:'icon_celve', label:' 策略'},
        {value:'icon_caozuo', label:' 操作'},
        {value:'icon_yichang2', label:' 异常'},
        {value:'icon_baojia', label:' 报价'},
        {value:'icon_hexiao', label:' 核销'},
        {value:'icon_qianbao2', label:' 钱包'},
        {value:'icon_moban', label:' 模板'},
        {value:'tms_menu_bao_biao', label:' tms-报表'},
        {value:'tms_menu_bao_jia', label:' tms-报价'},
        {value:'tms_menu_chu_na', label:' tms-出纳'},
        {value:'tms_menu_crm', label:' tms-crm'},
        {value:'tms_menu_jie_suan', label:' tms-结算'},
        {value:'tms_menu_ke_fu', label:' tms-客服'},
        {value:'tms_menu_ying_fu', label:' tms-应付'},
        {value:'tms_menu_ying_show', label:' tms-应收'},
        {value:'oms_menu_bao_jia', label:' oms-报价'},
        {value:'oms_menu_da_dan', label:' oms-打单'},
        {value:'oms_menu_ding_dan', label:' oms-订单'},
        {value:'oms_menu_fa_huo', label:' oms-发货'},
        {value:'oms_menu_lie_biao', label:' oms-列表'},
        {value:'oms_menu_pian_yuan', label:' oms-偏远'},
        {value:'oms_menu_shen_he', label:' oms-审核'},
        {value:'oms_menu_yi_chang', label:' oms-异常'},
        {value:'oms_menu_yu_e', label:' oms-余额'},
        {value:'oms_menu_zhang_dan', label:' oms-账单'}
    ]
};

/**
 * 翻译方法
 * zh -- 汉语
   en -- 英语
   ru -- 俄语
   ja -- 日语
   ko -- 韩语
   fr -- 法语
 * @param str
 * @param translateType
 */
zmGlobal.translate = function(str,translateType){
    return new Promise((resolve,reject) => {
        if(str){
            let type = translateType ? translateType : 'en';
            try {
                let _params = {
                    doctype:'json',
                    type:type,
                    i:str
                };
                // http://fanyi.youdao.com/translate
                // https://translate.yandex.net/api/v1.5/tr.json/translate?key=trnsl.1.1.20170721T082515Z.54cf3dc583f679db.f4a96182281281d8b5dfe24b4e88298e2133f219&lang=en&text=%E6%88%91%E5%9C%A8%E5%B9%B2%E5%98%9B
                let params2 = {
                    key:'trnsl.1.1.20170721T082515Z.54cf3dc583f679db.f4a96182281281d8b5dfe24b4e88298e2133f219',
                    lang:type,
                    text:str
                }

                httpservice.printGet2('https://translate.yandex.net/api/v1.5/tr.json/translate',params2).then(res => {
                    if(res && res.text && res.text.length){
                        resolve(res.text[0]);
                        /*let transObj = JSON.parse(res);
                        // JSONObject jsonObject = JSON.parseObject(responseRes);
                        if(transObj && transObj['translateResult'] && transObj['translateResult'].length > 0
                            && transObj['translateResult'][0] && transObj['translateResult'][0].length > 0 ){
                            resolve( transObj['translateResult'][0][0].tgt);
                        }else{
                            resolve('');
                        }*/
                    }else{
                        resolve('');
                    }

                })

            } catch(e) {
                reject();
            }
        }else{
            resolve('');
        }

    })
};


export default zmGlobal;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmGlobalService.js